module.exports = "/_next/static/images/badge-apple-app-store-light-eb4547d1254e99d107f3e004686d0a6d.svg";